// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Taviraj:wght@100;200;300;400;500;600;700;800;900&family=Roboto+Slab:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Taviraj', serif;
  font-weight: 400;
  background-color: #fafafa;
  color: #212121;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Roboto Slab', serif;
  font-weight: 600;
}

.App {
  min-height: 100vh;
}

/* Trampos colorline */
.colorline {
  margin: -4px auto 0 auto;
  width: 100%;
  height: 4px;
  background: linear-gradient(to right, 
    #4ec4c9 0%, #4ec4c9 25%, 
    #e2d000 25%, #e2d000 50%, 
    #eb8c3d 50%, #eb8c3d 75%, 
    #ef5b6e 75%, #ef5b6e 100%);
}

/* Toast customization */
.Toastify__toast {
  border-radius: 8px;
  font-family: 'Taviraj', serif;
}

.Toastify__toast--success {
  background-color: #4CAF50;
}

.Toastify__toast--error {
  background-color: #F44336;
}

.Toastify__toast--info {
  background-color: #2196F3;
}

/* Table responsive */
@media (max-width: 768px) {
  table {
    font-size: 0.9rem;
  }
  
  th, td {
    padding: 0.5rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX;;;;8BAI4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Taviraj:wght@100;200;300;400;500;600;700;800;900&family=Roboto+Slab:wght@300;400;500;600;700&display=swap');\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Taviraj', serif;\n  font-weight: 400;\n  background-color: #fafafa;\n  color: #212121;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Roboto Slab', serif;\n  font-weight: 600;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Trampos colorline */\n.colorline {\n  margin: -4px auto 0 auto;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(to right, \n    #4ec4c9 0%, #4ec4c9 25%, \n    #e2d000 25%, #e2d000 50%, \n    #eb8c3d 50%, #eb8c3d 75%, \n    #ef5b6e 75%, #ef5b6e 100%);\n}\n\n/* Toast customization */\n.Toastify__toast {\n  border-radius: 8px;\n  font-family: 'Taviraj', serif;\n}\n\n.Toastify__toast--success {\n  background-color: #4CAF50;\n}\n\n.Toastify__toast--error {\n  background-color: #F44336;\n}\n\n.Toastify__toast--info {\n  background-color: #2196F3;\n}\n\n/* Table responsive */\n@media (max-width: 768px) {\n  table {\n    font-size: 0.9rem;\n  }\n  \n  th, td {\n    padding: 0.5rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
